import ApexCharts from "./ApexCharts/index.vue";
import downloadable from "./Layouts/components/Downloadable.vue";
import score from "./Layouts/components/Score.vue";
import tabular from "./Layouts/components/Table.vue";
import locations from "./Layouts/components/LocationMap.vue";
import excel from "./Layouts/components/Downloadable.vue";
import ReportDatePicker from "../components/ReportDatePicker/index.vue";
import FilteredItems from "../components/FilteredItemsDropdown.vue";

const sourcePath = (path, details) => {
	if (!path) {
		return null;
	}

	let source = path;

	const { listingid, hospitalid, organisationid } = details;

	if (listingid && /{ListingID}/.test(source)) {
		source = source.replace("{ListingID}", listingid);
	}

	if (hospitalid !== null && /{HospitalID}/.test(source)) {
		source = source.replace("{HospitalID}", hospitalid);
	}

	if (organisationid !== null && /{OrganisationID}/.test(source)) {
		source = source.replace("{OrganisationID}", organisationid);
	}

	if (/{privateKey}/.test(source)) {
		source = source.replace("{privateKey}", 666);
	}

	return `${source}`;
};

export {
	ApexCharts,
	downloadable,
	score,
	tabular,
	locations,
	sourcePath,
	excel,
	ReportDatePicker,
	// GroupFilter,
	FilteredItems
	// UserFilter
};
